module.exports = __webpack_public_path__ + "img/button_home_on.5f732b8c.png";